import React, { useState, useRef, forwardRef } from "react";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/EmptyWithCenteredContent.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import Header from "components/headers/light.js";
import NavLinks from "components/misc/PapeNavLinks";
import { useReactToPrint } from "react-to-print";

const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
const ControlsContainer = tw.div`flex flex-row items-end justify-center gap-16`;
const Control = tw.div`flex flex-col items-start justify-center gap-4`;
const ControlLabel = tw.div`text-gray-800 text-sm font-bold`;
const Input = tw.input`bg-gray-100 px-2 py-2 rounded border-2 border-gray-400 hover:border-primary-500 focus:outline-none transition duration-300 w-48 text-center`;
const Slider = tw.input`w-48 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer`;
const SliderContainer = tw.div`flex flex-col items-center justify-center gap-2`;
const LetterPageContainer = tw.div`flex flex-col items-center justify-center gap-4`;
const LetterPageContent = tw.div`border-2 border-gray-800`;
const PrintButton = tw.button`bg-primary-500 text-gray-100 px-4 py-2 rounded hover:bg-primary-600 transition duration-300`;
const Column = tw.div`flex flex-col items-start justify-start gap-4 w-full h-full border-white border-solid outline outline-2 outline-gray-300 overflow-hidden`;

const SIZES = [
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
  "26px",
  "28px",
  "30px",
  "32px",
  "34px",
  "36px",
  "38px",
  "40px",
  "42px",
  "44px",
  "46px",
  "48px",
  "50px",
  "52px",
  "54px",
];

export default () => {
  const componentRef = useRef();
  const [name, setName] = useState("Juanito 1° A");
  const [size, setSize] = useState(0);
  const [columns, setColumns] = useState(3);
  const [margin, setMargin] = useState(4);

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
  });

  return (
    <AnimationRevealPage>
      <Header links={[<NavLinks key={1} />]} />
      <Hero
        heading={
          <>
            Plantilla de <HighlightedText>nombres</HighlightedText>
            <br />
            <div style={{ fontSize: 24, marginTop: 10 }}>
              Para identificación de útiles escolares
            </div>
          </>
        }
        description={
          <div style={{ fontSize: 20, textAlign: "left" }}>
            1. Escribe el nombre.
            <br />
            2. Ajusta el tamaño.
            <br />
            3. Selecciona la cantidad de columnas.
            <br />
            4. Imprime.
            <br />
            4. Pega.
          </div>
        }
      />

      <ControlsContainer>
        {/* add controls for the name, size and columns */}
        <Control>
          <ControlLabel>Nombre</ControlLabel>
          <Input
            type="text"
            placeholder="Juanito 1° A"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Control>
        <Control>
          <ControlLabel>Tamaño</ControlLabel>
          <SliderContainer>
            <span>{SIZES[size]}</span>
            <Slider
              type="range"
              min={0}
              max={SIZES.length - 1}
              value={size}
              onChange={(e) => setSize(parseInt(e.target.value))}
            />
          </SliderContainer>
        </Control>
        <Control>
          <ControlLabel>Columnas</ControlLabel>
          <SliderContainer>
            <span>{columns}</span>
            <Slider
              type="range"
              min="1"
              max="10"
              value={columns}
              onChange={(e) => setColumns(parseInt(e.target.value))}
            />
          </SliderContainer>
        </Control>
        <Control>
          <ControlLabel>Separación</ControlLabel>
          <SliderContainer>
            <span>{margin}</span>
            <Slider
              type="range"
              min="4"
              max="24"
              value={margin}
              onChange={(e) => setMargin(parseInt(e.target.value))}
            />
          </SliderContainer>
        </Control>
        <Control>
          <PrintButton onClick={handlePrint}>Imprimir</PrintButton>
        </Control>
      </ControlsContainer>

      <br />
      <LetterPageContainer>
        <LetterPageContent
          style={{ width: "816px", height: "1056px", padding: 1 }}
        >
          <div
            id="page"
            ref={componentRef}
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            {Array.from({ length: columns }).map((_, index) => (
              <Column
                key={index}
                style={{
                  height: "1050px",
                  borderTopWidth: "32px",
                  borderBottomWidth: "32px",
                  borderLeftWidth: index === 0 ? "32px" : "12px",
                  borderRightWidth: index === columns - 1 ? "32px" : "12px",
                }}
              >
                <div style={{ fontSize: SIZES[size], padding: "2px 4px" }}>
                  {Array.from({ length: 100 }).map((_, i) => (
                    <div key={i} style={{ marginBottom: margin }}>
                      {name}
                    </div>
                  ))}
                </div>
              </Column>
            ))}
          </div>
        </LetterPageContent>
      </LetterPageContainer>
      <br />
      <Footer />
    </AnimationRevealPage>
  );
};

// TODO: Add styles to css
// Custom styles for the slider
const sliderStyles = `
  input[type="range"]::-webkit-slider-thumb {
    appearance: none;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: #3b82f6;
    cursor: pointer;
    border: 2px solid #ffffff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }

  input[type="range"]::-moz-range-thumb {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: #3b82f6;
    cursor: pointer;
    border: 2px solid #ffffff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }

  input[type="range"]::-webkit-slider-track {
    background: #e5e7eb;
    height: 8px;
    border-radius: 4px;
  }

  input[type="range"]::-moz-range-track {
    background: #e5e7eb;
    height: 8px;
    border-radius: 4px;
  }
`;

// Add styles to document head
if (typeof document !== "undefined") {
  // Verificar si ya existe el estilo
  const existingStyle = document.getElementById("slider-styles");
  if (!existingStyle) {
    const style = document.createElement("style");
    style.id = "slider-styles"; // ID único
    style.textContent = sliderStyles;
    document.head.appendChild(style);
  }
}
